var React = require('react');

function ArrowBackward (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 6l5 5 1.414-1.414L3.83 7H12V5H3.829l2.585-2.586L5 1 0 6z","fill":"currentColor"}));
}

ArrowBackward.defaultProps = {"width":"12","height":"12","fill":"none"};

module.exports = ArrowBackward;

ArrowBackward.default = ArrowBackward;
